export default "__VITE_ASSET__CCjlFwqt__"